import React from "react";
import { Photo } from "./Photo.jsx";

/** Two-column masonry gallery with a full-width lead image. */
export function PhotoGallery({ items = [], columns = 2, gap = 8, style }) {
  const [lead, ...rest] = items;
  return (
    <div style={{ display: "grid", gap, ...style }}>
      {lead && <Photo {...lead} ratio={lead.ratio || "4 / 3"} />}
      <div style={{ display: "grid", gridTemplateColumns: `repeat(${columns}, 1fr)`, gap }}>
        {rest.map((it, i) => (
          <Photo key={i} {...it} ratio={it.ratio || "3 / 4"} />
        ))}
      </div>
    </div>
  );
}
